import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Mexico (1-45) with capital "M"
import Mexico1 from '../images/Mexico1.jpeg';
import Mexico2 from '../images/Mexico2.jpeg';
import Mexico3 from '../images/Mexico3.jpeg';
import Mexico4 from '../images/Mexico4.jpeg';
import Mexico5 from '../images/Mexico5.jpeg';
import Mexico6 from '../images/Mexico6.jpeg';
import Mexico7 from '../images/Mexico7.jpeg';
import Mexico8 from '../images/Mexico8.jpeg';
import Mexico9 from '../images/Mexico9.jpeg';
import Mexico10 from '../images/Mexico10.jpeg';
import Mexico11 from '../images/Mexico11.jpeg';
import Mexico12 from '../images/Mexico12.jpeg';
import Mexico13 from '../images/Mexico13.jpeg';
import Mexico14 from '../images/Mexico14.jpeg';
import Mexico15 from '../images/Mexico15.jpeg';
import Mexico16 from '../images/Mexico16.jpeg';
import Mexico17 from '../images/Mexico17.jpeg';
import Mexico18 from '../images/Mexico18.jpeg';
import Mexico19 from '../images/Mexico19.jpeg';
import Mexico20 from '../images/Mexico20.jpeg';
import Mexico21 from '../images/Mexico21.jpeg';
import Mexico22 from '../images/Mexico22.jpeg';
import Mexico23 from '../images/Mexico23.jpeg';
import Mexico24 from '../images/Mexico24.jpeg';
import Mexico25 from '../images/Mexico25.jpeg';
import Mexico26 from '../images/Mexico26.jpeg';
import Mexico27 from '../images/Mexico27.jpeg';
import Mexico28 from '../images/Mexico28.jpeg';
import Mexico29 from '../images/Mexico29.jpeg';
import Mexico30 from '../images/Mexico30.jpeg';
import Mexico31 from '../images/Mexico31.jpeg';
import Mexico32 from '../images/Mexico32.jpeg';
import Mexico33 from '../images/Mexico33.jpeg';
import Mexico34 from '../images/Mexico34.jpeg';
import Mexico35 from '../images/Mexico35.jpeg';
import Mexico36 from '../images/Mexico36.jpeg';
import Mexico37 from '../images/Mexico37.jpeg';
import Mexico38 from '../images/Mexico38.jpeg';
import Mexico39 from '../images/Mexico39.jpeg';
import Mexico40 from '../images/Mexico40.jpeg';
import Mexico41 from '../images/Mexico41.jpeg';
import Mexico42 from '../images/Mexico42.jpeg';
import Mexico43 from '../images/Mexico43.jpeg';
import Mexico44 from '../images/Mexico44.jpeg';
import Mexico45 from '../images/Mexico45.jpeg';

function Mexico() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    Mexico1, Mexico2, Mexico3, Mexico4, Mexico5, Mexico6, Mexico7, Mexico8, Mexico9, Mexico10,
    Mexico11, Mexico12, Mexico13, Mexico14, Mexico15, Mexico16, Mexico17, Mexico18, Mexico19, Mexico20,
    Mexico21, Mexico22, Mexico23, Mexico24, Mexico25, Mexico26, Mexico27, Mexico28, Mexico29, Mexico30,
    Mexico31, Mexico32, Mexico33, Mexico34, Mexico35, Mexico36, Mexico37, Mexico38, Mexico39, Mexico40,
    Mexico41, Mexico42, Mexico43, Mexico44, Mexico45
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇲🇽 Mexico 2022 🇲🇽</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Mexico ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Mexico;